import { render, staticRenderFns } from "./StepperEdit.vue?vue&type=template&id=47dbc5cd"
import script from "./StepperEdit.vue?vue&type=script&lang=ts"
export * from "./StepperEdit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports